$(document).ready(function () {
  $("#frequency-container").show();

  // When "One-time purchase" is clicked
  $("#one-time-purchase").on("change", function () {
    if ($(this).is(":checked")) {
      $("#frequency-container").hide();
    }
  });

  // When "Subscribe & Save" is clicked
  $("#subscribe-save").on("change", function () {
    if ($(this).is(":checked")) {
      $("#frequency-container").show();
    }
  });

  $(".bold-ro__frequency-num-custom").on("change", function () {
    let frequencyNum = $(this).val();
    console.log("Frequency Number selected: " + frequencyNum);
  });
});
